import { render, staticRenderFns } from "./WorkerCost.vue?vue&type=template&id=53fb0067&"
import script from "./WorkerCost.vue?vue&type=script&lang=js&"
export * from "./WorkerCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports